Controller.$inject = ['$scope'];

function Controller($scope) {
    const self = this;
    self.showLegend = false;
    self.inputFocused = false;

    self.handleFocus = () => {
        if (self.labelVariant === 'outlined') {
            self.showLegend = true;
        }
        self.inputFocused = true;
    };

    self.handleBlur = () => {
        if (!self.weekRange) {
            self.showLegend = false;
        }
        self.inputFocused = false;
    };

    self.onWeekChanged = ($event) => {
        self.onWeekSelected({$event});
    };

    $scope.$on('weekDatePickerInputFocused', function(event) {
        self.handleFocus();
    });

    $scope.$on('weekDatePickerInputBlured', function(event) {
        self.handleBlur();
    });
}

export function HuiInputWeekDatePicker() {
    return {
        restrict: 'E',
        scope: true,
        bindToController: {
            labelVariant: '@',
            iconPosition: '@',
            disabled: '<',
            hName: '@',
            hasError: '<',
            placeholder: '@',
            weekRange: '=',
            onWeekSelected: '&',
            startDayOfWeek: '=?',
            placement: '<',
            endDate: '='
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            label: '?huiInputLabel',
            icon: '?huiInputIcon'
        },
        template: ($element, $attrs) => {
            return `
              <hui-input-base
                label-variant="{{$huiCtrl.labelVariant}}"
                icon-position="{{$huiCtrl.iconPosition || 'start'}}"
                has-error="$huiCtrl.hasError"
                show-legend="$huiCtrl.showLegend"
                input-focused="$huiCtrl.inputFocused"
                model-value="$huiCtrl.weekRange"
                disabled="$huiCtrl.disabled">
                <hui-input-base-label ng-transclude ng-transclude-slot="label"></hui-input-base-label>
               <hui-input-base-icon ng-transclude ng-transclude-slot="icon"></hui-input-base-icon>
                <h-week-date-picker
                    ng-class="{'focused': $huiCtrl.inputFocused, 'disabled': $huiCtrl.disabled}"
                    name="{{$huiCtrl.hName}}"
                    class="date-picker"
                    placement="$huiCtrl.placement"
                    end-date="$huiCtrl.endDate"
                    ng-model="$huiCtrl.weekRange"
                    class="hui-date-input"
                    start-day-of-week="$huiCtrl.startDayOfWeek"
                    ng-focus="$huiCtrl.handleFocus()"
                    ng-blur="$huiCtrl.handleBlur()"
                    on-week-selected="$huiCtrl.onWeekChanged({weekRange})">
                </h-week-date-picker>
              </hui-input-base>
             `;
        }
    };
}


